import { TransparentButton } from '@approvalmax/ui';
import { PaperClipIcon } from '@approvalmax/ui/src/old/icons';
import styled from 'styled-components';

export const DeleteButton = styled(TransparentButton)`
    display: flex;
    align-items: center;
    justify-content: center;
    fill: #a4a1a1;
    padding: 5px;
    margin-left: auto;
    transition: 0.2s fill;

    &:hover {
        fill: #cb4e30;
    }
`;

export const Root = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid #cacccd;
    border-radius: 4px;
    padding: 0 5px 0 10px;
    height: 36px;
    width: 100%;
    gap: 6px;
`;

export const Name = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const FilePaperClipIcon = styled(PaperClipIcon)`
    flex-shrink: 0;
    color: #a0a1a1;
    fill: currentColor;
`;
